import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const FullStaticScreen = styled.div<{ imgDesktop: string; imgMobile: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${TabletWidth}px) {
    align-items: flex-end;
    background-image: url(${({ imgMobile }) => imgMobile});
  }
`;

export const FullStaticScreenContentWrapper = styled.div`
  width: 330px;
  text-align: left;

  margin: 0px 24px;
`;

export const FullStaticScreenLabel = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${getColor('GRAY_5')};
  margin-bottom: 8px;
`;

export const FullStaticScreenTitle = styled.h3`
  font-family: Lora;
  font-size: 42px;
  font-weight: 500;
  line-height: 48px;
  color: ${getColor('LIGHT_CREAM')};
  margin-bottom: 20px;
`;

export const FullStaticScreenDescription = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: ${getColor('GRAY_5')};
  margin-bottom: 12px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 32px;
  }
`;

export const FullStaticScreenQuoteChar = styled.img`
  margin-bottom: 12px;
`;

export const FullStaticScreenQuote = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 29px;
  color: ${getColor('WHITE')};
  margin-bottom: 8px;
`;

export const FullStaticScreenQuoteSubtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${getColor('WHITE')};
  margin-bottom: 12px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 32px;
  }
`;
export const FullStaticScreenCtaWrapper = styled.div`
  @media (max-width: ${TabletWidth}px) {
    margin: 16px 0px;
  }
`;
